import * as i0 from '@angular/core';
import * as i1 from './tooltip.module';
import * as i2 from '@angular/common';
import * as i3 from '@angular/forms';
import * as i4 from '@angular/router';
import * as i5 from '@angular/cdk/bidi';
import * as i6 from '@angular/cdk/scrolling';
import * as i7 from '@angular/cdk/overlay';
import * as i8 from '@angular/cdk/portal';
import * as i9 from '../cdk/overlay/mapping';
import * as i10 from '../cdk/overlay/overlay-container';
import * as i11 from '../icon/icon.component';
import * as i12 from './tooltip.component';
import * as i13 from './tooltip.directive';
import * as i14 from '../shared/shared.module';
import * as i15 from '../cdk/overlay/overlay.module';
import * as i16 from '../icon/icon.module';
export const NbTooltipModuleNgFactory:i0.NgModuleFactory<i1.NbTooltipModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.ɵangular_packages_forms_forms_z = (<any>(null as any));
var _decl0_12:i3.NgSelectOption = (<any>(null as any));
var _decl0_13:i3.ɵangular_packages_forms_forms_y = (<any>(null as any));
var _decl0_14:i3.DefaultValueAccessor = (<any>(null as any));
var _decl0_15:i3.NumberValueAccessor = (<any>(null as any));
var _decl0_16:i3.RangeValueAccessor = (<any>(null as any));
var _decl0_17:i3.CheckboxControlValueAccessor = (<any>(null as any));
var _decl0_18:i3.SelectControlValueAccessor = (<any>(null as any));
var _decl0_19:i3.SelectMultipleControlValueAccessor = (<any>(null as any));
var _decl0_20:i3.RadioControlValueAccessor = (<any>(null as any));
var _decl0_21:i3.NgControlStatus = (<any>(null as any));
var _decl0_22:i3.NgControlStatusGroup = (<any>(null as any));
var _decl0_23:i3.RequiredValidator = (<any>(null as any));
var _decl0_24:i3.MinLengthValidator = (<any>(null as any));
var _decl0_25:i3.MaxLengthValidator = (<any>(null as any));
var _decl0_26:i3.PatternValidator = (<any>(null as any));
var _decl0_27:i3.CheckboxRequiredValidator = (<any>(null as any));
var _decl0_28:i3.EmailValidator = (<any>(null as any));
var _decl0_29:i3.NgModel = (<any>(null as any));
var _decl0_30:i3.NgModelGroup = (<any>(null as any));
var _decl0_31:i3.NgForm = (<any>(null as any));
var _decl0_32:i3.NgFormSelectorWarning = (<any>(null as any));
var _decl0_33:i4.RouterOutlet = (<any>(null as any));
var _decl0_34:i4.RouterLink = (<any>(null as any));
var _decl0_35:i4.RouterLinkWithHref = (<any>(null as any));
var _decl0_36:i4.RouterLinkActive = (<any>(null as any));
var _decl0_37:i4.ɵangular_packages_router_router_l = (<any>(null as any));
var _decl0_38:i5.Dir = (<any>(null as any));
var _decl0_39:i6.CdkFixedSizeVirtualScroll = (<any>(null as any));
var _decl0_40:i6.CdkScrollable = (<any>(null as any));
var _decl0_41:i6.CdkVirtualForOf<any> = (<any>(null as any));
var _decl0_42:i6.CdkVirtualScrollViewport = (<any>(null as any));
var _decl0_43:i7.CdkConnectedOverlay = (<any>(null as any));
var _decl0_44:i7.CdkOverlayOrigin = (<any>(null as any));
var _decl0_45:i8.CdkPortal = (<any>(null as any));
var _decl0_46:i8.CdkPortalOutlet = (<any>(null as any));
var _decl0_47:i9.NbPortalDirective = (<any>(null as any));
var _decl0_48:i9.NbPortalOutletDirective = (<any>(null as any));
var _decl0_49:i10.NbOverlayContainerComponent = (<any>(null as any));
var _decl0_50:i11.NbIconComponent = (<any>(null as any));
var _decl0_51:i12.NbTooltipComponent = (<any>(null as any));
var _decl0_52:i13.NbTooltipDirective = (<any>(null as any));
var _decl0_53:i2.AsyncPipe = (<any>(null as any));
var _decl0_54:i2.UpperCasePipe = (<any>(null as any));
var _decl0_55:i2.LowerCasePipe = (<any>(null as any));
var _decl0_56:i2.JsonPipe = (<any>(null as any));
var _decl0_57:i2.SlicePipe = (<any>(null as any));
var _decl0_58:i2.DecimalPipe = (<any>(null as any));
var _decl0_59:i2.PercentPipe = (<any>(null as any));
var _decl0_60:i2.TitleCasePipe = (<any>(null as any));
var _decl0_61:i2.CurrencyPipe = (<any>(null as any));
var _decl0_62:i2.DatePipe = (<any>(null as any));
var _decl0_63:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_64:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_65:i2.KeyValuePipe = (<any>(null as any));
var _decl0_66:i14.NbSharedModule = (<any>(null as any));
var _decl0_67:i15.NbOverlayModule = (<any>(null as any));
var _decl0_68:i16.NbIconModule = (<any>(null as any));
var _decl0_69:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_70:i0.ElementRef<any> = (<any>(null as any));
function _View_NbTooltipComponent_Host_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_51.binding;
  currVal_0;
  const currVal_1:any = _decl0_51.show;
  currVal_1;
}
function _View_NbTooltipComponent_1_1():void {
  if (((_decl0_51.context == null)? (null as any): _decl0_51.context.icon)) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_51.context.icon;
    currVal_0;
    const currVal_1:any = _decl0_50.html;
    currVal_1;
    const currVal_2:any = _decl0_50.primary;
    currVal_2;
    const currVal_3:any = _decl0_50.info;
    currVal_3;
    const currVal_4:any = _decl0_50.success;
    currVal_4;
    const currVal_5:any = _decl0_50.warning;
    currVal_5;
    const currVal_6:any = _decl0_50.danger;
    currVal_6;
  }
}
function _View_NbTooltipComponent_1_2():void {
  if (_decl0_51.content) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_51.content;
    currVal_0;
  }
}
function _View_NbTooltipComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = ((_decl0_51.context == null)? (null as any): _decl0_51.context.icon);
  currVal_0;
  const currVal_1:any = _decl0_51.content;
  currVal_1;
}
